<template>
  <v-modal
      v-if="containers.showModalHoras === false"
      title=""
      :show="show"
      @close="$emit('close')"
      size="lg"
      buttonClose="true"
  >
    <ui-spinner v-if="loading.view"></ui-spinner>
    <template v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Número *</label>
            <input type="number" v-model="number" class="form-control form-control-sm">
          </div>
          <div class="form-group">
            <label for="" class="form-label">Tipo *</label>
            <div class="form-check mb-2">
              <input class="form-check-input" type="radio" v-model="idType" :value="1" id="radioTipo1">
              <label class="form-check-label" for="radioTipo1">
                IN
              </label>
            </div>
            <div class="form-check mb-2">
              <input class="form-check-input" type="radio" v-model="idType" :value="2" id="radioTipo2">
              <label class="form-check-label" for="radioTipo2">
                OUT
              </label>
            </div>
          </div>
          <div class="text-right">
            <button
                class="btn btn-sm btn-outline-success"
                :disabled="loading.crud"
                @click="onNew"
            >
              Nuevo
            </button>
            <button
                class="ml-2 btn btn-sm btn-primary"
                :disabled="loading.crud"
                @click="onSave"
            >
              Guardar
            </button>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-secondary">
              <tr class="text-center align-middle">
                <th style="width: 80px"></th>
                <th>Número</th>
                <th>Tipo</th>
                <th>UC</th>
                <th>UM</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="item in containers.numeros"
                  :key="item.idTren"
                  class="align-middle text-center"
              >
                <td style="width: 100px">
                  <template v-if="item.origen != 0">
                    <button
                        class="btn btn-xs btn-icon btn-light-warning"
                        @click="onEdit(item)"
                    >
                      <span class="fa fa-fw fa-pencil-alt"></span>
                    </button>
                    <button
                        class="btn btn-xs btn-icon btn-light-danger ml-2"
                        @click="onDelete(item)"
                    >
                      <span class="fa fa-fw fa-trash-alt"></span>
                    </button>
                  </template>
                  <button
                      @click="onShowModalTrenNumeros(item)"
                      class="btn btn-xs btn-icon btn-light-primary ml-1"
                  >
                    <span class="fa fa-fw fa-list"></span>
                  </button>
                </td>
                <td>{{ item.nroTren }}</td>
                <td>{{ item.tipoLetras }}</td>
                <td>{{ item.usuarioCreador }}</td>
                <td>{{ item.usuarioModif }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </v-modal>
  <ModalTrenNumeroHoras
      v-else
      :show="true"
      :tren-servicio="tren"
      :tren="containers.tren"
      @close="containers.showModalHoras = false;"
  />
</template>
<script>
const vModal = () =>
    import(/* webpackChunkName: "ui-modal" */ "@/components/vModal");
const ModalTrenNumeroHoras = () => import('@/modals/TrenNumeroHoras');

export default {
  components: {
    vModal,
    ModalTrenNumeroHoras
  },
  props: ["show", "tren"],
  data() {
    return {
      number: "",
      idType: "",
      loading: {
        view: true,
        crud: false,
      },
      containers: {
        id: null,
        numeros: [],
        showModalHoras: false,
        tren: null
      },
    };
  },
  async created() {
    let vm = this;

    let response = await vm.axios.get(
        `/mantenimiento/trenes/${vm.tren.idTrenServicio}/numeros`
    );
    vm.containers.numeros = response.data.content.numeros;

    vm.loading.view = false;
  },
  methods: {
    onSave() {
      let vm = this;
      let fd = {
        number: vm.number,
        idType: vm.idType,
        _method: "POST",
      };

      if (!(fd.number && fd.idType)) {
        return vm.$swal.fire(
            "",
            "Completa los campos obligatorios (*)",
            "warning"
        );
      }

      vm.loading.crud = true;

      let endpoint = `/mantenimiento/trenes/${vm.tren.idTrenServicio}/numeros`;

      if (vm.containers.id) {
        endpoint = `/mantenimiento/trenes/${vm.tren.idTrenServicio}/numeros/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
          .post(endpoint, fd)
          .then((response) => {
            if (vm.containers.id) {
              let findRow = vm.containers.numeros.find(
                  (item) => item.idTren == vm.containers.id
              );
              findRow.nroTren = fd.number;
              findRow.tipoLetras = fd.idType == 1 ? 'IN' : 'OUT';
              findRow.usuarioModif = vm.$store.state.user.codigo;
            } else {
              vm.containers.numeros.push({
                idTren: response.data.content.id,
                nroTren: fd.number,
                tipoLetras: fd.idType == 1 ? 'IN' : 'OUT',
                usuarioCreador: vm.$store.state.user.codigo,
              });

              vm.containers.id = response.data.content.id;
            }

            vm.$toast.fire(response.data.message, "", "success");
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
    },
    onEdit(pItem) {
      this.number = pItem.nroTren;
      this.idType = pItem.tipo;
      this.containers.id = pItem.idTren;
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire(
          "",
          "¿Seguro que desea eliminar este item?"
      );

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
            .delete(
                `/mantenimiento/trenes/${vm.tren.idTrenServicio}/numeros/${pItem.idTren}`
            )
            .then((response) => {
              let tempRegistros = [...vm.containers.numeros];
              vm.containers.numeros = tempRegistros.filter(
                  (item) =>
                      item.idTren !=
                      pItem.idTren
              );
              vm.onNew();
            })
            .catch((error) => {
              vm.$toast.fire(error.response.data.message, "", "error");
            })
            .finally(() => {
              vm.loading.crud = false;
            });
      }
    },
    onNew() {
      let vm = this;
      vm.number = "";
      vm.idType = "";
      vm.containers.id = null;
    },
    onShowModalTrenNumeros (pItem) {
      const vm = this;
      vm.containers.showModalHoras = true;
      vm.containers.tren = pItem;
    }
  },
};
</script>
